<template>
  <div class="w-full flex flex-col items-center alpha-bottom from-black">
    <div
      class="w-full max-w-7xl flex flex-col gap-3 sm:flex-row items-center justify-between py-3 px-2 xl:px-0"
    >
      <NuxtLink to="/" class="-mb-1">
        <img :src="logoUrl" alt="Logo" class="w-full max-w-[150px]" />
      </NuxtLink>

      <div
        class="w-full flex flex-row flex-wrap items-center justify-center sm:justify-end gap-3"
      >
        <a class="link" :class="linkBreakpoint" :href="joinUrl">Movies</a>
        <a
          class="link"
          :class="linkBreakpoint"
          href="/top-rated"
          @click="navigate($event, '/top-rated')"
        >
          Top Rated
        </a>
        <a
          class="link"
          :class="linkBreakpoint"
          href="/models"
          @click="navigate($event, '/models')"
        >
          Models
        </a>
        <a
          v-if="hasSubSites"
          class="link"
          :class="linkBreakpoint"
          href="/sites"
          @click="navigate($event, '/sites')"
        >
          Sites
        </a>

        <TourAgeVerificationCTA v-if="showAgeVerification" />

        <AppButton
          v-if="!inMembersArea"
          color="white"
          variant="outline"
          class="uppercase text-lg text-white"
          to="/login"
        >
          Login
        </AppButton>

        <AppCtaButton
          v-if="!inMembersArea"
          class="uppercase"
          size="mini"
          :href="joinUrl"
        >
          Join Now
        </AppCtaButton>
      </div>
    </div>
    <Divider />
  </div>
</template>

<script setup>
  defineOptions({
    name: "TourClassicNavigation",
  })

  const currentSite = inject("currentSite")
  const logoUrl = `/images/sites/${currentSite.value.slug}/logo.png`
  const joinUrl = "/join"
  const { inMembersArea } = useMembersArea()
  const { hasSubSites } = useSiteSettings(currentSite.value)
  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")
  const { ageVerificationEnabled } = useRuntimeConfig().public
  const showAgeVerification = ageVerificationEnabled && inAgeRestrictedLocation

  // The links sit beside the age-verification pill, so they wait for the
  // room to fit both; below that the pill shows alone.
  const linkBreakpoint = showAgeVerification
    ? "hidden lg:block"
    : "hidden sm:block"

  const navigate = (e, path, external = false) => {
    e.preventDefault()
    return navigateTo(path, { external })
  }
</script>

<style scoped>
  .link {
    @apply text-xl text-white hover:text-gray-400 font-bold tracking-tight;
  }
</style>
